import { stringLiteral } from '@execonline-inc/decoders';
import { Decoder, field, succeed, string, number, array, oneOf, nullable } from 'jsonous';
import { resourceDecoder } from '../../../../../../Resource/Decoders';
import {
  SectionTypeOptions,
  BrowseAllDefaults,
  DisplayType,
  LearningDesign,
  SchoolPartner,
  Competency,
} from '../Types/SectionTemplates';

const displayTypeDecoder: Decoder<DisplayType> = oneOf([
  stringLiteral<DisplayType>('carousel'),
  stringLiteral<DisplayType>('list'),
  stringLiteral<DisplayType>('grid'),
]);

const browseAllDefaultsDecoder: Decoder<BrowseAllDefaults> = succeed({})
  .assign('name', field('name', string))
  .assign('description', field('description', string))
  .assign('display_type', field('display_type', displayTypeDecoder))
  .assign('experiences', field('experiences', array(number)));

// Decoder for school partners with logo URLs
const schoolPartnerDecoder: Decoder<SchoolPartner> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', string))
  .assign('logo_url', field('logo_url', nullable(string)));

// Decoder for competencies with name and description
const competencyDecoder: Decoder<Competency> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', nullable(string)))
  .assign('description', field('description', nullable(string)));

// Decoder for individual curated learning designs - only decode what server returns
const learningDesignDecoder: Decoder<LearningDesign> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', string))
  .assign('description', field('description', string))
  .assign('experiences', field('experiences', array(number)))
  .assign('school_partners', field('school_partners', array(schoolPartnerDecoder)))
  .assign('competencies', field('competencies', array(competencyDecoder)));

const sectionTypeOptionsPayloadDecoder: Decoder<SectionTypeOptions> = succeed({})
  .assign('browse_all', field('browse_all', browseAllDefaultsDecoder))
  .assign('curated', field('curated', array(learningDesignDecoder)));

export const sectionTypeOptionsDecoder = resourceDecoder(sectionTypeOptionsPayloadDecoder);
